import { Component, OnInit } from '@angular/core';
import * as Highcharts from "highcharts";
import HC_more from "highcharts/highcharts-more";
import { ReportCountByStatus } from "../../../../models/analytics.model";
import { AnalyticsService } from '../../../../services/analytics.service';
import { LookupService } from '../../../../services/lookups/lookup.service';
HC_more(Highcharts);


@Component({
  selector: 'app-reports-count-by-status-card',
  templateUrl: './reports-count-by-status-card.component.html',
  styleUrls: ['./reports-count-by-status-card.component.css']
})
export class ReportsCountByStatusCardComponent implements OnInit {

  updateFromInput: boolean = false;
  reportStates:string[]=[];
  requiredReportCnt:ReportCountByStatus;
  voluntaryReportCnt:ReportCountByStatus;
  selectedReportYear: number;

  ReportCountByStatusChart: typeof Highcharts = Highcharts;
  ReportCountByStatusChartOptions:any;
  constructor(private lookupService:LookupService,private analyticsService: AnalyticsService) { }

  ngOnInit() {
     this.GetReportStates();
  }

  loadReportsCountsByStatusChart(yearId:number,year:number)
  {

    this.selectedReportYear = year;
    this.analyticsService.getReportsCountByStatus$(yearId).subscribe((data)=>{
      if(data)
      {
       this.requiredReportCnt= data.filter(x=>x.isRequired ===true)[0];
       this.voluntaryReportCnt= data.filter(x=>x.isRequired ===false)[0];

      this.GetChartOptions();
      this.updateFromInput=true;
      }
    });
  }

  GetChartOptions()
  {
    this.ReportCountByStatusChartOptions={
        chart: {
            type: 'column',
            plotBorderWidth: 0,
            plotShadow: false,
            width:460,
            height:500
        },
        title: {
            text: 'Reports based on Status for ' + this.selectedReportYear,
            style:{"color":"#337ab7","fontSize":"16px","fontWeight":"bold" }
        },
        xAxis: {
            categories: this.reportStates
        },
        yAxis: {
            min: 0,
            title: {
                text: 'No. of Reports'
            },
            stackLabels: {
                enabled: true,
                style: {
                    fontWeight: 'bold',
                    color: ( // theme
                        Highcharts.defaultOptions.title.style &&
                        Highcharts.defaultOptions.title.style.color
                    ) || 'gray'
                }
            }
        },
        // legend: {
        //     align: 'right',
        //     x: -30,
        //     verticalAlign: 'top',
        //     y: 25,
        //     floating: true,
        //     backgroundColor:
        //         Highcharts.defaultOptions.legend.backgroundColor || 'white',
        //     borderColor: '#CCC',
        //     borderWidth: 1,
        //     shadow: false
        // },
        tooltip: {
            headerFormat: '<b>{point.x}</b><br/>',
            pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
        },
        plotOptions: {
            column: {
                stacking: 'normal',
                dataLabels: {
                    enabled: true
                }

            }

        },
        credits:{
          enabled:false
        },
        series: [{
          type:'column',
           name: 'Voluntary',
           data: [this.voluntaryReportCnt.notStarted,
             this.voluntaryReportCnt.draft,
             this.voluntaryReportCnt.submittedToPostApprover,
             this.voluntaryReportCnt.approvedAndSentToWashington,
             this.voluntaryReportCnt.returnedFromPostApprover,
             this.voluntaryReportCnt.returnedFromWashington,
             //this.voluntaryReportCnt.validated,
             this.voluntaryReportCnt.published,
             this.voluntaryReportCnt.hold
             ],//[12, 12, 18, 12, 12,10,10,10,10],
           color: Highcharts.getOptions().colors[7]
       },{
          type:'column',
          name: 'Required',
            data: [this.requiredReportCnt.notStarted,
                   this.requiredReportCnt.draft,
                   this.requiredReportCnt.submittedToPostApprover,
                   this.requiredReportCnt.approvedAndSentToWashington,
                   this.requiredReportCnt.returnedFromPostApprover,
                   this.requiredReportCnt.returnedFromWashington,
                   //this.requiredReportCnt.validated,
                   this.requiredReportCnt.published,
                   this.requiredReportCnt.hold
                   ],                      //[15, 13, 14, 17, 21,10,10,10,10],
            color: Highcharts.getOptions().colors[8]
        }]
    };
  }


  private GetReportStates(){
    this.lookupService.getReportStates$().subscribe(data=>{

       this.reportStates =data.filter(x=>x.stateName != 'Validated').map(a=>a.stateName);
       this.GetChartOptions();
       this.updateFromInput=true;
       //console.log(this.reportStates);
    });

  }
}
